// extracted by mini-css-extract-plugin
export default {"labelText":"Ak+ohH8U","emailField":"QfyVBwnD","error":"CrXyCm7e","submitButton":"FD9hkOrw","resetButton":"NXFK0Ruz"};